// eslint-disable-next-line import/prefer-default-export
export const menuPad = { horizontal: 'medium', vertical: 'xsmall' };
